import { Input, Select, DatePicker } from 'antd';
import { TagOutlined } from '@ant-design/icons';
import type { Dayjs } from 'dayjs';
import TagFilter from '../article-list/TagFilter';
import { useIsMobile } from '../../hooks/useIsMobile';
import { useResetOnBreakpoint } from '../../components/filters/useResetOnBreakpoint';
import MobileMediaFilterBar from './MobileMediaFilterBar';

export interface MediaFilters {
  q?: string;
  tagId?: string;
  categoryId?: string;
  dateFrom?: number;
  dateTo?: number;
}

export interface MediaFilterBarProps {
  categories: { value: string; label: string }[];
  onChange: (patch: Partial<MediaFilters>) => void;
}

type Range = [Dayjs | null, Dayjs | null] | null;

/** 媒體庫篩選：手機改用可收合面板，桌機維持原本一列工具列。 */
export default function MediaFilterBar(props: MediaFilterBarProps) {
  useResetOnBreakpoint(() =>
    props.onChange({ q: undefined, tagId: undefined, categoryId: undefined, dateFrom: undefined, dateTo: undefined }),
  );
  return useIsMobile() ? <MobileMediaFilterBar {...props} /> : <DesktopMediaFilterBar {...props} />;
}

/** 桌機篩選列：記者是用「刊出時間 + 標籤」找舊照片的，這兩個放最顯眼。 */
function DesktopMediaFilterBar({ categories, onChange }: MediaFilterBarProps) {
  const handleRange = (v: Range) =>
    onChange({
      dateFrom: v?.[0]?.startOf('day').valueOf(),
      dateTo: v?.[1]?.endOf('day').valueOf(),
    });

  return (
    <div className="mb-4 flex flex-wrap items-center gap-2 rounded-xl border border-black/5 bg-white p-3 shadow-sm">
      <Input.Search
        placeholder="關鍵字（檔名、圖說、文章標題）"
        allowClear
        style={{ width: 280 }}
        onSearch={(v) => onChange({ q: v.trim() || undefined })}
      />
      <TagFilter onChange={(tagId) => onChange({ tagId })} />
      <Select
        placeholder="分類"
        allowClear
        suffixIcon={<TagOutlined />}
        style={{ width: 150 }}
        onChange={(categoryId) => onChange({ categoryId })}
        options={categories}
      />
      <DatePicker.RangePicker
        allowClear
        placeholder={['刊出日（起）', '刊出日（迄）']}
        onChange={handleRange}
      />
    </div>
  );
}
